import React from 'react';
import {Container} from './styles';

export default function WordCounter({total, current}) {
    
    return (
        <Container>
           {current} de {total} palabras
        </Container>
    )}